
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai",
      function () {
        return require("private-next-pages/ai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai"])
      });
    }
  